import React from 'react';
import { Image } from '@tangibleplay/core-ui';

import { StyledCartProductMiniature } from './CartProductMiniature.styles';

import { CartProductMiniatureProps } from './CartProductMiniature.types';

const CartProductMiniature = ({
  product,
  productPrice,
  productQuantity,
  deleteProductFromCartContent = null,
  onDeleteProductFromCartClick = () => {},
  beforeTitleSlot,
  afterTitleSlot,
  beforeContent,
  afterContent,
  children,
  componentClassname = 'cart-product-miniature',
  customClassnames = '',
  customStyle = '',
}: CartProductMiniatureProps) => {
  if (!product.id) product.id = product.title;

  return (
    <StyledCartProductMiniature
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      {beforeContent}

      <div className={`${componentClassname}__content`}>
        {product.image_link && (
          <div className={`${componentClassname}__image`}>
            <Image src={product.image_link} alt={product.title} style={{}} />
          </div>
        )}

        <div className={`${componentClassname}__name`}>
          {beforeTitleSlot}
          {product.title}
          {afterTitleSlot}
        </div>

        {productPrice && (
          <div className={`${componentClassname}__price`}>{productPrice}</div>
        )}

        {productQuantity && (
          <div className={`${componentClassname}__quantity`}>
            {productQuantity}
          </div>
        )}

        {deleteProductFromCartContent && (
          <button
            type="button"
            className={`${componentClassname}__delete-from-cart`}
            onClick={() => {
              onDeleteProductFromCartClick(product.id);
            }}
          >
            {deleteProductFromCartContent}
          </button>
        )}

        {children}
      </div>

      {afterContent}
    </StyledCartProductMiniature>
  );
};
CartProductMiniature.displayName = 'CartProductMiniature';

export default CartProductMiniature;
